var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.navigation_class,attrs:{"id":"app"}},[(_vm.$root.navigation)?_c(_vm.navigation_component,{tag:"component",attrs:{"current_section":_vm.active_section}}):_vm._e(),_c('router-view',{on:{"change-section":_vm.update_section}}),_c('TheFooter',{attrs:{"dark_mode":_vm.$root.dark_mode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }